export default __webpack_public_path__ + "static/animacion-seccion-banner-home-f6132551240e73656784b07f76169b1f.png";